module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('span', [(!_vm.revealAnswers) ? _vm._c('span', {
    directives: [{
      name: "scroll-in-view-when",
      rawName: "v-scroll-in-view-when",
      value: (_vm.active),
      expression: "active"
    }],
    staticClass: "clex-keyword",
    class: {
      active: _vm.active, answered: _vm.answered
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.select($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.visibleContent))]) : _vm._c('span', {
    staticClass: "clex-keyword answer",
    class: {
      correct: _vm.answerIsCorrect, wrong: !_vm.answerIsCorrect
    },
    domProps: {
      "innerHTML": _vm._s(_vm.answerDiff)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d0cb6d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/Keyword.vue
// module id = 700
// module chunks = 1